export function getCardKind(isSelected, isDragged) {
    if (isSelected) {
        return 'card.selected';
    }
    if (isDragged) {
        return 'card.raised';
    }
    return 'card.default';
}
